// Wording shared by attempt entry and review of the recorded proof facts.
export const serviceAttemptOutcomeLabels: Record<string, string> = {
  served_recipient: 'Documents handed to named recipient',
  served_substitute: 'Documents handed to another person',
  no_contact: 'No contact observed',
  address_not_found: 'Address not found',
  access_blocked: 'Access blocked',
};
